export const priceConverter = (number) => {
  return number.toLocaleString('en-US', {
    maximumFractionDigits: 2,
    style: 'currency',
    currency: 'USD'
  })
}
